namespace $ {
	export class $shm_hitalama_components_drafts_store extends $giper_baza_entity.with({
		Owner: $giper_baza_atom_text,
		// Keys are links to independent document areas; values are their display titles.
		Entries: $giper_baza_dict_to( $giper_baza_atom_text ),
	}) {}
}
